import * as React from "react";
import {TemplateItem} from "./TemplateItem";
import {EmptyTemplateItem} from "./EmptyTemplateItem";
import {TemplatePagination} from "./TemplatePagination";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {ToastService} from "../../../../shared/utilities/services/ToastService";

@observer
export class TemplateList extends React.Component<TemplateListProps, TemplateListState> {
    static defaultProps: Partial<TemplateListProps> = {};
    public categories:CategoryList[];
    public allTemplates:TemplateItemDto[]=[];

    constructor(props: TemplateListProps) {
        super(props);
        this.categories=[];
        this.state = {
            IsBusy:true,
            Index:0,
            Size:9,
            Templates:[],
            LoadingData:false
        };
    }


    componentDidMount(): void {
        this.Load();
    }

    public render() {
        return (
            <div id={'sfTemplateList'} style={{display:'inline-flex',flexWrap:'wrap',height:'100%',maxWidth:'none'}}>
                <div style={{width:300,padding:5,borderRight:'1px solid #dfdfdf'}} >
                    <div style={{position:'absolute',bottom:0,textAlign:'center',left:0,width:300}}>
                        <img src={smartFormsRootPath+'images/logo_block.png'}/>
                    </div>
                    <h3 style={{marginTop:2,marginBottom:5}}>Categories</h3>
                    {this.categories.map(x=>
                        <div style={{marginLeft:10}} key={x.Id}>
                            <input id={'cb'+x.Id} checked={x.Selected} onChange={y=>{x.Selected=y.target.checked;this.FiltersUpdated()}} type={'checkbox'} style={{margin:0,marginRight:5}}/>
                            <label htmlFor={'cb'+x.Id} style={{fontSize:15,fontWeight:'normal',margin:0}}>{x.Name}</label>
                        </div>
                    )}

                </div>
                <div style={{width:1,flexGrow:1,overflow:'auto',height:'100%'}}>
                    <div style={{display:'flex',flexWrap:'wrap',justifyContent:'center',margin:5}}>
                        {
                            this.state.Templates.length==0?<EmptyTemplateItem OnClick={x=>this.CreateEmptyForm()}/>:
                            this.state.Templates.slice(9*this.state.Index,9*this.state.Index+9).map((x,y)=>
                                x.Id=='0'?
                                   <EmptyTemplateItem key={0} OnClick={x=>this.CreateEmptyForm()}/>:
                                <TemplateItem key={y} Id={x.Id} Name={x.Name} OnClick={y=>this.CreateForm(x)} OnClickPreview={y=>this.CreatePreview(x.Id)} Requirements={x.RequiredOptions}/>
                            )

                        }
                        <TemplatePagination PageChanged={x=>this.setState({Index:x})} Index={this.state.Index} Size={this.state.Size}/>

                    </div>



                    {this.state.IsBusy &&
                        <div style={{display:'flex',alignItems:'center',justifyContent:'center',fontSize:25}} >
                            <li style={{margin:0}} className={'fa fa-spinner fa-spin'}></li>
                            <h4 style={{marginLeft:5}}>Loading Templates, please wait...</h4>
                        </div>
                    }
                </div>
                <div style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',opacity:this.state.LoadingData?1:0,visibility:this.state.LoadingData?'visible':'hidden',transition:'opacity 200ms ease-in-out'}}>
                    <div style={{width:'100%',height:'100%',backgroundColor:'#000',opacity:.7}}></div>
                    <div style={{position:'absolute',width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',color:'white',top:0,left:0}}>
                        <h2><span className={'fa fa-spinner fa-spin'}></span> Loading form data, please wait...</h2>
                    </div>
                </div>
            </div>
        )
    }

    private Load() {
        rnJQuery.getJSON(smartFormsPath+'js/dist/list.json',result=>{
            this.categories=[];
            for(let item of result.CategoryList)
            {
                let category=new CategoryList();
                category.Id=item.Id;
                category.Name=item.Name;
                category.Selected=false;
                this.categories.push(category);
            }
            this.allTemplates=result.Templates;
            this.UpdateTemplatesToShow(this.allTemplates);

            this.setState({IsBusy:false});

        })
    }

    public AddEmptyFormTemplates(templates:any){
        return
    }

    private FiltersUpdated() {
        if(this.categories.filter(x=>x.Selected).length==0)
        {
            this.UpdateTemplatesToShow(this.allTemplates);
            return;
        }


        let selectedCategories=this.categories.filter(x=>x.Selected).map(x=>x.Id);
        debugger;
        this.UpdateTemplatesToShow(this.allTemplates.filter(
            x=>x.Categories.find(
                        y=>selectedCategories.indexOf(y.toString())>=0)!=null));

    }

    private UpdateTemplatesToShow(templatesToShow: TemplateItemDto[]) {
        let templates=[].concat([{
            Categories:[],
            Id:'0',
            Name:'Empty Form',
            RequiredOptions:[],
            VideoURL:''

        }],templatesToShow);
        this.setState({Size:templates.length,Templates:templates,Index:0})
    }

    private CreateEmptyForm() {
        this.props.CreateForm(null);
    }

    private CreateForm(item: TemplateItemDto) {

        if(item.RequiredOptions.length>0)
        {
            if(!RedNaoLicensingManagerVar.LicenseIsValid('Sorry, this template use a feature only available in the full version'))
            {
                return;
            }
        }

        this.setState({LoadingData:true});
        rnJQuery.getJSON('https://smartforms.rednao.com/wp-content/uploads/smart_forms_templates/template_'+item.Id+'/data.export',result=>{
           this.props.CreateForm(result);
        }).error(x=>{
            this.setState({LoadingData:false});
            ToastService.SendErrorMessage('An error occurred, please try again.')
        });
    }

    private CreatePreview(Id: string) {
        this.setState({LoadingData:true});
        rnJQuery.getJSON('https://smartforms.rednao.com/wp-content/uploads/smart_forms_templates/template_'+Id+'/data.export',result=>{
            this.props.CreatePreview(result);
            this.setState({LoadingData:false});
        }).error(x=>{
            this.setState({LoadingData:false});
            ToastService.SendErrorMessage('An error occurred, please try again.')
        });
    }
}

declare let RedNaoSmartFormLicenseIsValid:boolean;
//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateListProps {
    CreateForm(args:any);
    CreatePreview(args:any);
}

interface TemplateListState {
    IsBusy:boolean;
    LoadingData:boolean;
    Index:number;
    Size:number;
    Templates:TemplateItemDto[];

}

interface TemplateItemDto{
    Id:string;
    Name:string;
    VideoURL:string;
    RequiredOptions:string[];
    Categories:number[];
}

class CategoryList{
    Id:string;
    Name:string;
    @observable Selected:boolean;
}

declare let rnJQuery:any;
declare let smartFormsPath;
//#endregion "My Region"